import React from 'react';
import { Box, BoxProps } from '@mui/material';

export default function CellContainer({ children, sx, ...other }: BoxProps) {
  return (
    <Box
      sx={{
        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'center',
        overflow: 'hidden',
        ...sx,
      }}
      {...other}
    >
      {children}
    </Box>
  );
}
